import { Translation, required } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { minLength, noWhiteStartOrEnd } from '@swf/core/utils/validators';

import TextInput from '../../../../TextInput/TextInput';
import RMFDropDown from '../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_Answers_must_be_at_least_2_cha_ELL,
  TXTWCL_Answer_N0,
  TXTWCL_Please_enter_your_information__ELL,
  TXTWCL_Please_make_your_selection_to__ELL,
  TXTWCL_Question_N0,
  TXTWCL_Select_a_question
} from './SecurityQuestionsFields.messages.json';
import { container, label } from './SecurityQuestionsFields.scss';

const answerMinLength = 2;
const question1FieldName = 'question1';
const question2FieldName = 'question2';
const answer1FieldName = 'answer1';
const answer2FieldName = 'answer2';

const SecurityQuestionsFields: React.FC = () => {
  const {
    input: { value: question1Value }
  } = useField(question1FieldName, { subscription: { value: true } });
  const {
    input: { value: question2Value }
  } = useField(question2FieldName, { subscription: { value: true } });
  const {
    data: { realMoneyInformation }
  } = useWizardContext();
  const { securityQuestions } = realMoneyInformation || {};

  const getOptions = () => {
    let options = [] as { value: number; text: string }[];

    if (securityQuestions?.length) {
      options = securityQuestions.map((item) => ({
        text: item.question,
        value: item.id
      }));
    }

    return options;
  };

  const options = getOptions();
  const filterQuestions = (selectedQuestion: number) =>
    options.filter((item) => item.value !== selectedQuestion);

  return (
    <>
      <RMFDropDown
        id={question1FieldName}
        label={TXTWCL_Question_N0}
        values={{ 0: 1 }}
        options={filterQuestions(question2Value)}
        validators={[required(TXTWCL_Please_make_your_selection_to__ELL)]}
        placeholder={<Translation {...TXTWCL_Select_a_question} />}
        className={container}
      />
      <TextInput
        id={answer1FieldName}
        label={TXTWCL_Answer_N0}
        values={{ 0: 1 }}
        minLength={answerMinLength}
        validators={[
          noWhiteStartOrEnd,
          required(TXTWCL_Please_enter_your_information__ELL),
          minLength(answerMinLength, { ...TXTCLI_Answers_must_be_at_least_2_cha_ELL })
        ]}
        className={container}
        checkDisabled
      />
      <RMFDropDown
        id={question2FieldName}
        label={TXTWCL_Question_N0}
        values={{ 0: 2 }}
        options={filterQuestions(question1Value)}
        validators={[required(TXTWCL_Please_make_your_selection_to__ELL)]}
        placeholder={<Translation {...TXTWCL_Select_a_question} />}
        className={container}
        labelClassName={label}
      />
      <TextInput
        id={answer2FieldName}
        label={TXTWCL_Answer_N0}
        values={{ 0: 2 }}
        minLength={answerMinLength}
        validators={[
          noWhiteStartOrEnd,
          required(TXTWCL_Please_enter_your_information__ELL),
          minLength(answerMinLength, { ...TXTCLI_Answers_must_be_at_least_2_cha_ELL })
        ]}
        className={container}
        checkDisabled
      />
    </>
  );
};

export default SecurityQuestionsFields;
